// src/components/global-ui/GlobalModals.tsx
import React, {Fragment} from "react";
import useUiStore from "../../store/useUiStore.ts";
import {Dialog, DialogPanel, Transition, TransitionChild} from "@headlessui/react";
import {twMerge} from "tailwind-merge";
import SmartIcon from "../SmartIcon.tsx";

const GlobalModals: React.FC = () => {
  const {modal, closeModal} = useUiStore();

  return (
    <Transition show={modal.isVisible} as={Fragment}>
      <Dialog
        className={`fixed inset-0 z-50 flex p-6 overflow-auto scroll-smooth md:px-4 ${modal.configuration?.className}`}
        onClose={closeModal}
      >
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div
            className={`fixed inset-0 ${
              modal.configuration?.presentingVideo ? "bg-n-700/95" : "bg-n-700/75 dark:bg-n-600/90"
            } ${modal.configuration?.classOverlay}`}
            aria-hidden="true"
          />
        </TransitionChild>
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom={`opacity-0 ${!modal.configuration?.presentingVideo && "scale-95"}`}
          enterTo={`opacity-100 ${!modal.configuration?.presentingVideo && "scale-100"}`}
          leave="ease-in duration-200"
          leaveFrom={`opacity-100 ${!modal.configuration?.presentingVideo && "scale-100"}`}
          leaveTo={`opacity-0 ${!modal.configuration?.presentingVideo && "scale-95"}`}
        >
          <DialogPanel
            className={twMerge(
              `relative z-10 max-w-[37.5rem] w-full m-auto bg-n-100 rounded-3xl dark:bg-n-700 ${
                modal.configuration?.presentingVideo &&
                "static max-w-[64rem] aspect-video rounded-[1.25rem] bg-n-700 overflow-hidden shadow-[0_2.5rem_8rem_rgba(0,0,0,0.5)]"
              } ${modal.configuration?.classWrap}`
            )}
          >
            {modal.content}
            <button
              className={twMerge(
                `text-0 fill-n-700 hover:fill-primary-1 ${
                  modal.configuration?.presentingVideo &&
                  "absolute top-6 right-6 w-10 h-10 bg-n-100 rounded-full"
                } ${modal.configuration?.classButtonClose}`
              )}
              onClick={closeModal}
            >
              <SmartIcon
                className="fill-inherit transition-colors"
                name="close"
              />
            </button>
          </DialogPanel>
        </TransitionChild>
      </Dialog>
    </Transition>
  );
};

export default GlobalModals;